import React from 'react';
import './Spinner.scss';

const spinner = () => (
  <div className="loader">Loading...</div>
);

export default spinner;